import { getTimeFilterISO } from "@/components/base/FilterBar";

export const generationStatusLabels: Record<string, { cls: string; label: string }> = {
  created: { cls: "bg-slate-500/10 text-slate-600", label: "已创建" },
  queued: { cls: "bg-amber-500/10 text-amber-600", label: "排队中" },
  generating: { cls: "bg-brand/10 text-brand", label: "生成中" },
  auditing: { cls: "bg-cyan-500/10 text-cyan-600", label: "审核中" },
  success: { cls: "bg-emerald-500/10 text-emerald-500", label: "成功" },
  failed: { cls: "bg-red-500/10 text-red-500", label: "失败" },
  blocked: { cls: "bg-orange-500/10 text-orange-600", label: "已拦截" },
  timeout: { cls: "bg-red-500/10 text-red-600", label: "已超时" },
  cancelled: { cls: "bg-slate-500/10 text-slate-500", label: "已取消" },
  refunded: { cls: "bg-violet-500/10 text-violet-600", label: "已退款" },
  pending: { cls: "bg-amber-500/10 text-amber-500", label: "等待中" },
  processing: { cls: "bg-brand/10 text-brand", label: "处理中" },
};

interface GenerationQueryInput {
  page: number;
  pageSize: number;
  userId: string;
  status: string;
  userType: string;
  sourceEntry: string;
  entryId: string;
  toolId: string;
  timeRange: string;
  startDate: string;
  endDate: string;
}

export function buildGenerationQueryParams(input: GenerationQueryInput) {
  const params: Record<string, string | number> = {
    page: input.page,
    page_size: input.pageSize,
  };
  if (input.userId) params.user_id = input.userId;
  if (input.status) params.status = input.status;
  if (input.userType) params.user_type = input.userType;
  if (input.sourceEntry) params.source_entry = input.sourceEntry;
  if (input.entryId) params.entry_id = input.entryId;
  if (input.toolId) params.tool_id = input.toolId;
  if (input.timeRange === "custom") {
    if (input.startDate) params.date_from = `${input.startDate}T00:00:00+08:00`;
    if (input.endDate) params.date_to = `${input.endDate}T23:59:59.999+08:00`;
  } else {
    const presetStart = getTimeFilterISO(input.timeRange);
    if (presetStart) params.date_from = presetStart;
  }
  return params;
}
